import {GET_SERVICES_PAGE_START} from "store/constants";

export const getServicesPage = () => ({
    type: GET_SERVICES_PAGE_START
});